<template>
  <a-layout-sider
    class="sidebar-a-layout"
    :width="settings.leftMenuWidth"
    :collapsedWidth="settings.isMobileView ? 0 : 49"
    :trigger="null"
    :collapsible="settings.isMobileView ? false : true"
    :collapsed="settings.isMenuCollapsed && !settings.isMobileView"
    @collapse="onCollapse"
    :class="{
      [$style.menu]: true,
      [$style.white]: settings.menuColor === 'white',
      [$style.gray]: settings.menuColor === 'gray',
      [$style.dark]: settings.menuColor === 'dark',
      [$style.unfixed]: settings.isMenuUnfixed,
      [$style.shadow]: settings.isMenuShadow,
    }"
  >
    <div
      :class="$style.menuOuter"
      :style="{
        width:
          settings.isMenuCollapsed && !settings.isMobileView
            ? '49px'
            : settings.leftMenuWidth + 'px',
        height: 'calc(100%)',
      }"
    >
      <div :class="$style.logoContainer">
        <div :class="$style.logo">
          <img
            v-if="settings.isMenuCollapsed && !settings.isMobileView"
            src="/resources/images/new-ui/sidebar/logo-mark.svg"
            alt="Routr"
            style="height: 28px; width: auto"
          />
          <img
            v-else
            src="/resources/images/new-ui/sidebar/logo.svg"
            alt="Routr"
            style="height: 28px; width: auto"
          />
        </div>
      </div>
      <vue-custom-scrollbar
        :style="{
          height:
            settings.isMobileView || settings.isMenuUnfixed
              ? 'calc(100% - 64px)'
              : 'calc(100vh - 110px)',
          overflowY: 'auto',
          overflowX: 'clip'
        }"
      >
        <a-menu
          forceSubMenuRender
          :inlineCollapsed="
            settings.isMobileView ? false : settings.isMenuCollapsed
          "
          :mode="'inline'"
          :selectedKeys="selectedKeys"
          :openKeys.sync="openKeys"
          @click="handleClick"
          @openChange="handleOpenChange"
          :inlineIndent="15"
          :class="settings.isMenuCollapsed ? $style.navigation2: $style.navigation"
          id="sidebar-item"
        >
          <template v-for="(item, index) in menuData">
            <template v-if="isItemVisible(item, index)">
              <a-menu-item-group
                id="sidebar-tip"
                :key="index"
                v-if="item.category"
              >
                <template slot="title">{{ item.title }}</template>
              </a-menu-item-group>
              <item
                :disabled="item.disabled"
                v-if="!item.children && !item.category"
                :menu-info="item"
                :styles="$style"
                :collapsed="settings.isMenuCollapsed"
                :key="item.key"
              />
              <!-- <item
                :disabled="item.disabled"
                v-if="!item.children && !item.category && index !== 0"
                :menu-info="item"
                :styles="$style"
                :collapsed="settings.isMenuCollapsed"
                :key="item.key"
              /> -->
              <sub-menu
                id="sidebar-item-submenu"
                v-if="item.children"
                :menu-info="item"
                :styles="$style"
                :key="item.key"
              />
            </template>
          </template>
        </a-menu>
      </vue-custom-scrollbar>
      <a-tooltip placement="right" :title="settings.menuToggleLockReason">
        <div
          :class="$style.sidebarFooter"
          :style="settings.menuToggleLockReason ? 'cursor: not-allowed; opacity: 0.5' : ''"
          @click="onCollapse"
          :title="settings.menuToggleLockReason ? '' : 'Toggle sidebar'"
        >
          <img
            :src="
              settings.isMenuCollapsed && !settings.isMobileView
                ? '/resources/images/new-ui/sidebar/expand.svg'
                : '/resources/images/new-ui/sidebar/collapse.svg'
            "
            alt="Toggle sidebar"
            class="sb-footer-icon"
          />
        </div>
      </a-tooltip>
    </div>
  </a-layout-sider>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import store from 'store'
import find from 'lodash/find'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import { getMenuData, getSettingMenuData } from '@/services/menu'
import SubMenu from './partials/submenu'
import Item from './partials/item'


export default {
  name: 'menu-left',
  components: { vueCustomScrollbar, SubMenu, Item },
  computed: {
    ...mapState(['settings']),
    ...mapGetters('user', ['user']),
    ...mapGetters('permissions', { canView: 'canView' }),
    currentRoleSlug() {
      return this.user.roleSlug || ''
    },
  },
  mounted() {
    this.openKeys = store.get('app.menu.openedKeys') || []
    this.selectedKeys = store.get('app.menu.selectedKeys') || []
    this.syncMenuTypeToRoute()
    this.setSelectedKeys()
  },
  data() {
    return {
      menuData: getMenuData,
      selectedKeys: [],
      openKeys: [],
    }
  },
  watch: {
    'settings.isMenuCollapsed'() {
      this.openKeys = []
    },
    'settings.menuType'() {
      this.settings.menuType === 'main'
        ? (this.menuData = getMenuData)
        : (this.menuData = getSettingMenuData)
    },
    $route() {
      this.syncMenuTypeToRoute()
      this.setSelectedKeys()
    },
  },
  methods: {
    syncMenuTypeToRoute() {
      const isPreferencesRoute = this.$route.path.startsWith('/preferences')
      const expectedType = isPreferencesRoute ? 'preferences' : 'main'
      if (this.settings.menuType !== expectedType) {
        this.$store.commit('CHANGE_MENU_TYPE', { menuType: expectedType })
      }
      this.menuData = isPreferencesRoute ? getSettingMenuData : getMenuData
    },
    isChildVisible(item) {
      if (item.orgIds && !(this.user.organization && item.orgIds.includes(this.user.organization.id))) {
        return false
      }
      if (item.resource) {
        if (!this.canView(item.resource)) return false
      }
      if (item.roles) {
        const allowed = Array.isArray(item.roles) ? item.roles : [item.roles]
        if (!allowed.includes(this.currentRoleSlug)) return false
      }
      return true
    },
    isItemVisible(item, index) {
      if (item.category) {
        for (let i = index + 1; i < this.menuData.length; i++) {
          if (this.menuData[i].category) break
          if (this.isChildVisible(this.menuData[i])) return true
        }
        return false
      }
      return this.isChildVisible(item)
    },
    onCollapse() {
      if (this.settings.menuToggleLockReason) return
      this.$store.commit('CHANGE_SETTING', {
        setting: 'isMenuCollapsed',
        value: !this.settings.isMenuCollapsed,
      })
    },
    handleClick(e) {
      // if (e.key === 'settings') {
      //   this.$store.commit('CHANGE_SETTING', {
      //     setting: 'isSettingsOpen',
      //     value: true,
      //   })
      //   return
      // }
      store.set('app.menu.selectedKeys', [e.key])
      this.selectedKeys = [e.key]
      if (e.key === 'gotoDashboard') {
        store.set('app.menu.selectedKeys', ['contracts'])
        this.selectedKeys = ['contracts']
      }
    },
    handleOpenChange(openKeys) {
      store.set('app.menu.openedKeys', openKeys)
      this.openKeys = openKeys
    },
    setSelectedKeys() {
      const pathname = this.$route.path
      const menuData = this.menuData.concat()
      const flattenItems = (items, key) =>
        items.reduce((flattenedItems, item) => {
          flattenedItems.push(item)
          if (Array.isArray(item[key])) {
            return flattenedItems.concat(flattenItems(item[key], key))
          }
          return flattenedItems
        }, [])
      const selectedItem = find(flattenItems(menuData, 'children'), [
        'url',
        pathname,
      ])
      this.selectedKeys = selectedItem ? [selectedItem.key] : []
      if(pathname === '/preferences/profile') {
        this.selectedKeys= ['profile']
      }
      if (pathname.startsWith('/preferences/vendors')) {
        this.selectedKeys = ['prefVendors']
      }
      // /messages/:id keeps the Messages entry lit while a message is open.
      if (pathname.startsWith('/messages/')) {
        this.selectedKeys = ['messaging']
      }
    },
  },
}
</script>

<style lang="scss" module>
@import './style.module.scss';
</style>
<style lang="scss">
/* ============================================================
   Routr 2026 sidebar — pixel-perfect Figma implementation
   ============================================================ */
.ps__rail-y {
  display: none !important;
}

/* Sider shell: white with a 1px right divider */
.sidebar-a-layout {
  // border-right: 1px solid #d9dee2;
  background: #fff !important;
  z-index: 1000 !important;
}
.sb-footer-icon {
  width: 16px;
  height: 16px;
  display: block;
}
.sidebar-a-layout .ant-layout-sider-children {
  background: #fff !important;
}

/* Menu container */
#sidebar-item.ant-menu {
  background: #fff !important;
  border-right: none !important;
  padding: 8px !important;
}

/* Group / category label */
#sidebar-item .ant-menu-item-group-title {
  height: 32px;
  display: flex;
  align-items: center;
  padding: 0 8px !important;
  margin: 8px 0 0 !important;
  font-family: 'Inter', sans-serif;
  font-weight: 500 !important;
  font-size: 12px !important;
  line-height: 16px !important;
  letter-spacing: 0 !important;
  text-transform: none !important;
  color: rgba(39, 59, 74, 0.7) !important;
}

/* Menu item pill */
#sidebar-item .ant-menu-item {
  height: 36px !important;
  line-height: 20px !important;
  margin: 0 !important;
  padding: 8px !important;
  border-radius: 8px !important;
  display: flex;
  align-items: center;
  color: #273b4a !important;
  transition: background 0.15s ease !important;
}
#sidebar-item .ant-menu-item::after {
  display: none !important;
}

/* Link row inside an item */
#sidebar-item .sb-link {
  display: flex !important;
  align-items: center !important;
  gap: 8px;
  width: 100%;
  margin: 0 !important;
}
#sidebar-item .sb-icon {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  display: block;
  object-fit: contain;
}
#sidebar-item .sb-icons {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
}
#sidebar-item .sb-icon-font {
  font-size: 16px !important;
  color: #273b4a !important;
  flex: 0 0 16px;
  line-height: 16px;
}
#sidebar-item .sb-title {
  flex: 1 1 auto;
  min-width: 0;
  font-family: 'Inter', sans-serif;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  color: #273b4a !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Soft badge */
#sidebar-item .sb-badge {
  flex: 0 0 auto;
  min-width: 18px;
  height: 18px;
  padding: 2px 6px;
  border-radius: 9999px;
  background: rgba(11, 58, 76, 0.1);
  color: #273b4a;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Hover — subtle neutral wash (Aya keeps its own branded state) */
#sidebar-item .ant-menu-item:not(.ant-menu-item-selected):not(.sb-item--dashboard):not(.sb-item--aya):hover,
#sidebar-item .ant-menu-item-active:not(.ant-menu-item-selected):not(.sb-item--dashboard):not(.sb-item--aya) {
  background: rgba(39, 59, 74, 0.06) !important;
}

/* Selected — light pill, text stays dark */
#sidebar-item .ant-menu-item-selected {
  background: #e7ecee !important;
}
#sidebar-item .ant-menu-item-selected .sb-title {
  color: #273b4a !important;
}

/* Aya — permanent branded lavender highlight (resting / hover) */
#sidebar-item .sb-item--aya,
#sidebar-item .sb-item--aya:hover {
  background: radial-gradient(
    80% 200% at 55% 120%,
    rgba(151, 100, 247, 0.24) 0%,
    rgba(151, 100, 247, 0) 70%
  ) !important;
}
/* Aya — selected: stronger lavender → selected-gray gradient */
#sidebar-item .sb-item--aya.ant-menu-item-selected {
  background: radial-gradient(
    80% 220% at 30% 120%,
    rgba(203, 177, 251, 0.95) 0%,
    rgba(231, 236, 238, 0.64) 68%
  ) !important;
}
#sidebar-item.ant-menu-inline-collapsed .sb-item--aya,
#sidebar-item.ant-menu-inline-collapsed .sb-item--aya:hover {
  background: radial-gradient(
    circle at 50% 60%,
    rgba(151, 100, 247, 0.18) 0%,
    rgba(151, 100, 247, 0.05) 100%
  ) !important;
}
#sidebar-item.ant-menu-inline-collapsed .sb-item--aya.ant-menu-item-selected {
  background: radial-gradient(
    circle at 50% 55%,
    rgba(203, 177, 251, 0.55) 0%,
    rgba(231, 236, 238, 0.7) 100%
  ) !important;
}

/* Disabled */
#sidebar-item .ant-menu-item-disabled .sb-title {
  color: rgba(39, 59, 74, 0.5) !important;
}
#sidebar-item .ant-menu-item-disabled .sb-icon {
  opacity: 0.5;
}

/* Preferences "Dashboard" — dark navy back-to-app button */
#sidebar-item .sb-item--dashboard,
#sidebar-item .sb-item--dashboard.ant-menu-item-selected,
#sidebar-item .sb-item--dashboard:hover {
  background: #0b3a4c !important;
}
#sidebar-item .sb-item--dashboard .sb-title {
  color: #ffffff !important;
  font-weight: 600 !important;
}
#sidebar-item .sb-item--dashboard .sb-badge {
  background: rgba(103, 131, 152, 0.35);
  color: #ffffff;
}

/* ===== Collapsed (49px rail) ===== */
#sidebar-item.ant-menu-inline-collapsed {
  width: 49px !important;
  padding: 8px !important;
}
#sidebar-item.ant-menu-inline-collapsed .ant-menu-item {
  width: 33px !important;
  padding: 8px !important;
  justify-content: center;
}
#sidebar-item.ant-menu-inline-collapsed .sb-link {
  justify-content: center;
  gap: 0;
}
#sidebar-item.ant-menu-inline-collapsed .sb-title,
#sidebar-item.ant-menu-inline-collapsed .sb-badge {
  display: none !important;
}
/* Collapsed: hide the label text but keep a gap between groups */
#sidebar-item.ant-menu-inline-collapsed .ant-menu-item-group-title {
  visibility: hidden;
  height: 18px !important;
  margin: 4px 0 0 !important;
  padding: 0 !important;
}
/* No group divider lines in the collapsed rail */
.sidebar-a-layout.ant-layout-sider-collapsed #sidebar-item .ant-menu-item-group::after {
  display: none !important;
}
#sidebar-item.ant-menu-inline-collapsed .sb-item--dashboard .sb-icons {
  gap: 0;
}

/* Collapsed hover tooltip */
.ant-menu-inline-collapsed-tooltip .ant-tooltip-inner {
  min-width: auto;
  min-height: 21px;
  padding: 2px 10px !important;
  background: #0b3a4c !important;
  color: #ffffff !important;
  border-radius: 4px !important;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 17px;
  box-shadow: none !important;
}
/* Arrow is the rotated ::before square — color it, drop the default shadow */
.ant-menu-inline-collapsed-tooltip .ant-tooltip-arrow::before {
  background-color: #0b3a4c !important;
  box-shadow: none !important;
}
/* Tooltip content is the item's children; show only the label text */
.ant-menu-inline-collapsed-tooltip .ant-tooltip-inner .sb-link {
  display: block;
  gap: 0;
  width: auto;
  margin: 0 !important;
  padding: 0 !important;
  color: #ffffff !important;
}
.ant-menu-inline-collapsed-tooltip .ant-tooltip-inner .sb-title {
  display: inline !important;
  color: #ffffff !important;
  font-size: 12px !important;
  line-height: 17px !important;
  font-weight: 500 !important;
}
.ant-menu-inline-collapsed-tooltip .ant-tooltip-inner .sb-icon,
.ant-menu-inline-collapsed-tooltip .ant-tooltip-inner .sb-icons,
.ant-menu-inline-collapsed-tooltip .ant-tooltip-inner .sb-badge {
  display: none !important;
}
</style>
